import type { ApexOptions } from 'apexcharts'
import type { CommunityTimeSeriesData } from '../../../features/engagement/domain/models/community'
import { buildLineChartOptions, CommunityChartColors, longDateFormatter, type ChartSeriesItem } from '../charts'

export interface CommunityLegendState {
  [key: string]: boolean
  posts: boolean
  views: boolean
  comments: boolean
  upvotes: boolean
}

export interface CommunityLegendItem {
  key: string
  label: string
  color: string
}

export const COMMUNITY_LEGEND_ITEMS: CommunityLegendItem[] = [
  { key: 'posts', label: 'Posts', color: CommunityChartColors.posts },
  { key: 'views', label: 'Views', color: CommunityChartColors.views },
  { key: 'comments', label: 'Comments', color: CommunityChartColors.comments },
  { key: 'upvotes', label: 'Upvotes', color: CommunityChartColors.upvotes }
]

export const COMMUNITY_INITIAL_LEGEND_STATE: CommunityLegendState = {
  posts: true,
  views: true,
  comments: true,
  upvotes: true
}

export const getCommunityChartOptions = (
  data: CommunityTimeSeriesData[],
  legend: CommunityLegendState
): ApexOptions => {
  const categories = data.map((d) => d.date)

  const series: ChartSeriesItem[] = []

  if (legend.posts) {
    series.push({
      name: 'Posts',
      data: data.map((d) => d.posts),
      color: CommunityChartColors.posts
    })
  }

  if (legend.views) {
    series.push({
      name: 'Views',
      data: data.map((d) => d.views),
      color: CommunityChartColors.views
    })
  }

  if (legend.comments) {
    series.push({
      name: 'Comments',
      data: data.map((d) => d.comments),
      color: CommunityChartColors.comments
    })
  }

  if (legend.upvotes) {
    series.push({
      name: 'Upvotes',
      data: data.map((d) => d.upvotes),
      color: CommunityChartColors.upvotes
    })
  }

  return buildLineChartOptions({
    series,
    categories,
    tooltipHeaderFormatter: longDateFormatter
  })
}
